import { useEffect } from "react";

export const GA_MEASUREMENT_ID = "G-0MKVR1R97T";

function appendScript({ id, src, async = false }) {
  if (document.getElementById(id)) return;

  const script = document.createElement("script");
  script.id = id;
  script.src = src;
  script.async = async;
  document.head.appendChild(script);
}

function hasAnalyticsConsent() {
  if (typeof window === "undefined") return false;
  return Boolean(window.Cookiebot?.consent?.statistics);
}

function getPageLocation() {
  if (typeof window === "undefined") return "/";
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}

function updateAnalyticsConsent(granted) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  window.__gaAnalyticsGranted = granted;
  window.gtag("consent", "update", {
    analytics_storage: granted ? "granted" : "denied"
  });
}

function trackPageView(path = getPageLocation()) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (!window.__gaAnalyticsGranted) return;

  window.gtag("event", "page_view", {
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: document.title
  });
}

export default function useConsentBootstrap() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };

    window.gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
      functionality_storage: "denied",
      personalization_storage: "denied",
      security_storage: "granted",
      wait_for_update: 2000
    });
    window.gtag("set", "ads_data_redaction", true);
    window.gtag("set", "url_passthrough", true);

    appendScript({
      id: "google-gtag",
      src: `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`,
      async: true
    });

    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
      anonymize_ip: true,
      send_page_view: false
    });

    window.__gaTrackPageView = trackPageView;

    const syncConsent = () => {
      const granted = hasAnalyticsConsent();
      const wasGranted = Boolean(window.__gaAnalyticsGranted);
      updateAnalyticsConsent(granted);

      if (granted && !wasGranted) {
        trackPageView();
      }
    };

    const consentEvents = [
      "CookiebotOnConsentReady",
      "CookiebotOnAccept",
      "CookiebotOnDecline"
    ];

    consentEvents.forEach((eventName) => {
      window.addEventListener(eventName, syncConsent);
    });

    syncConsent();
    const consentSyncTimeout = window.setTimeout(syncConsent, 1500);

    return () => {
      consentEvents.forEach((eventName) => {
        window.removeEventListener(eventName, syncConsent);
      });
      window.clearTimeout(consentSyncTimeout);
    };
  }, []);
}
